module.exports = __webpack_public_path__ + "img/Icon awesome-equals.3b63e550.svg";